import { Route as SlowMovingRoute } from "@/routes/(inventory)/branch/_layout/reports/slow-moving-items/index";
import { useQuery } from "@tanstack/react-query";
import { getSlowMovingItems } from "../-data/api";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useSlowMovingItemsData = () => {
  const searchParams = SlowMovingRoute.useSearch();
  
  return useQuery<ReportQueryResult>({
    queryKey: ["slow-moving-items", searchParams],
    queryFn: async () => {
      const response = await getSlowMovingItems(searchParams.page || 1, searchParams.pageSize || 10);
      return {
        items: response.slowMovingItems,
        totalCount: response.totalCount,
        page: searchParams.page || 1,
        pageSize: searchParams.pageSize || 10,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};